if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.read-more-content');
      this.button = this.querySelector('.read-more-button');
      this.isExpanded = false;
      this.maxHeight = parseInt(this.getAttribute('data-max-height')) || 100;
    }
    connectedCallback() {
      if (this.content && this.button) {
        this.content.style.transition = 'max-height 0.3s ease';
        
        // Initial layout check
        setTimeout(() => {
          this.originalHeight = this.content.scrollHeight;
          this.checkHeight();
        }, 100);
        this.resizeHandler = this.checkHeight.bind(this);
        window.addEventListener('resize', this.resizeHandler);
        this.button.addEventListener('click', this.toggle.bind(this));
      }
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
    }
    checkHeight() {
      if (this.hasAttribute('data-mobile-only') && window.innerWidth >= 768) {
        this.content.style.maxHeight = 'none';
        this.content.style.overflow = 'visible';
        this.button.style.display = 'none';
        return;
      }
      // Check original height to determine if we need the button
      // To get accurate height, we temporarily remove max height
      const currentMaxHeight = this.content.style.maxHeight;
      this.content.style.maxHeight = 'none';
      this.originalHeight = this.content.scrollHeight;
      this.content.style.maxHeight = currentMaxHeight;
      if (this.originalHeight > this.maxHeight + 20) {
        if (!this.isExpanded) {
          this.content.style.maxHeight = `${this.maxHeight}px`;
          this.content.style.overflow = 'hidden';
          // Use CSS to add a fade out effect at the bottom when collapsed
          this.content.style.webkitMaskImage = 'linear-gradient(to bottom, black 50%, transparent 100%)';
          this.content.style.maskImage = 'linear-gradient(to bottom, black 50%, transparent 100%)';
        } else {
          this.content.style.webkitMaskImage = 'none';
          this.content.style.maskImage = 'none';
        }
        this.button.style.display = 'inline-block';
      } else {
        this.content.style.maxHeight = 'none';
        this.content.style.overflow = 'visible';
        this.button.style.display = 'none';
        this.content.style.webkitMaskImage = 'none';
        this.content.style.maskImage = 'none';
      }
    }
    toggle() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.content.style.maxHeight = `${this.originalHeight}px`;
        this.content.style.webkitMaskImage = 'none';
        this.content.style.maskImage = 'none';
        this.button.textContent = this.getAttribute('data-text-less') || 'Read Less';
        
        setTimeout(() => {
          if (this.isExpanded) this.content.style.maxHeight = 'none';
        }, 300);
      } else {
        this.content.style.maxHeight = `${this.originalHeight}px`;
        void this.content.offsetHeight; // force reflow
        this.content.style.maxHeight = `${this.maxHeight}px`;
        this.content.style.webkitMaskImage = 'linear-gradient(to bottom, black 50%, transparent 100%)';
        this.content.style.maskImage = 'linear-gradient(to bottom, black 50%, transparent 100%)';
        this.button.textContent = this.getAttribute('data-text-more') || 'Read More';
      }
    }
  }
  customElements.define('read-more', ReadMore);
}